<div [class]="{'justify-content-between': filters, 'justify-content-start': !filters}" class="card-header bg-white w-100 gap-2 px-2 d-flex">
  @if (filters) {
    <div class="d-flex gap-2 align-items-center">
      @for (filter of filters; track $index) {
        <button (click)="handleFilter(filter.value)" [ngClass]="{'btn-dark bg-colonial': activeFilter == filter.value, 'btn-light': activeFilter !== filter.value}" class="btn btn-sm rounded-3 border-0">{{filter.label}}</button>
      }
      <ng-content select="[sharedTableCustomFilter]"></ng-content>
    </div>
  }
  <div class="d-flex gap-2">
    @if (searchPlaceholder) {
      <input (input)="clearTimeout(searchTimeout)" (keyup)="handleSearch($event)" [(ngModel)]="searchValue" [placeholder]="searchPlaceholder" class="form-control float-end form-control-sm border rounded-3" style="max-width: 300px; height: 30px;" type="text">
    }
    @if (exportExcel.observed) {
      <button (click)="exportExcel.emit()"
        [disabled]="!items.length"
        class="btn btn-outline-secondary d-flex align-items-center justify-content-between">
        @if (loadingExport) {
          <div class="spinner-border text-secondary h-50 w-50" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        } @else {
          <span class="material-symbols-outlined">description</span>
          Excel
        }
      </button>
    }
  </div>
  @if (actionButtonTitle) {
    <div class="d-flex float-end">
      <button (click)="actionButtonClicked.emit()" class="btn btn-sm btn-dark bg-colonial border-0 rounded-3 px-2">{{actionButtonTitle}}</button>
    </div>
  }
</div>
<div class="card-body p-0" >
  @if (items.length) {
    @if (bulkActions && bulkActions.length && itemsSelected.length) {
      <div class="bg-warning-subtle border-warning rounded py-2 px-3 m-2">
        <div class="d-flex gap-2 align-items-center">
          <label class="small fw-semibold">({{itemsSelected.length}}) Elementos selecionados: </label>
          @for (action of bulkActions; track $index) {
            <button (click)="handleActionClicked(action)" class="btn btn-sm btn-outline-dark">{{action.label}}</button>
          }
        </div>
      </div>
    }
    <div class="table-responsive">
      <table class="table table-hover m-0 align-middle">
        <thead class="small">
          <tr>
            @if (draggable) {
              <th class="text-uppercase h6 mb-0 text-muted bg-light" style="width: 30px;"></th>
            }
            @if ((bulkActions && bulkActions.length) || itemsSelectedChange.observed) {
              <th class="text-uppercase h6 mb-0 text-muted bg-light" style="width: 30px;">
                <input (change)="selectAll($event)" [checked]="itemsSelected.length == items.length" aria-label="Checkbox for following text input" class="form-check-input mt-0" type="checkbox" value="">
              </th>
            }
            @for (header of headers; track $index) {
              <th class="small text-uppercase text-muted bg-light fw-semibold" style="min-width: 60px;">
                <small>
                  {{header.label}}
                </small>
              </th>
            }
          </tr>
        </thead>
        <tbody [cdkDropListDisabled]="!draggable" (cdkDropListDropped)="drop($event)" cdkDropList>
          @for (item of items; track item.id) {
            <tr (click)="handleItemClicked(item)" [cdkDragDisabled]="!draggable" [style.cursor]="draggable ? 'default' : 'pointer'" cdkDrag>
              @if (draggable) {
                <td (click)="$event.stopPropagation()" cdkDragHandle style="cursor: grab; width: 30px;">
                  <span class="material-symbols-outlined text-muted">drag_indicator</span>
                </td>
              }
              @if ((bulkActions && bulkActions.length) || itemsSelectedChange.observed) {
                <td>
                  <input (change)="selectItem(item)" (click)="$event.stopPropagation()" [checked]="isItemSelected(item.id)" aria-label="Checkbox for following text input" class="form-check-input mt-0" type="checkbox" value="">
                </td>
              }
              @for (header of headers; track $index) {
                <td [class]="getItemClass(header, item)">
                  <div class="d-grid" style="text-wrap: nowrap;" >
                    @if (templatesIndex[header.attribute]) {
                      <span class="small">
                        <ng-template [ngTemplateOutlet]="templatesIndex[header.attribute].templateRef" [ngTemplateOutletContext]="item"></ng-template>
                      </span>
                    } @else {
                      @if(typeof (item | property: header.attribute) !== 'number' && !(item | property: header.attribute)){
                        <span
                          class="small">N/A</span>
                      } @else {
                        @switch (header.type) {
                          @case ('image') {
                            <span class="small border rounded-circle overflow-hidden" style="width: 40px; height: 40px">
                            <img [src]="item | property: header.attribute | imageUrl" class="w-100 h-100" style="object-fit: cover">
                          </span>
                          }
                          @case ('money') {
                            <span
                              class="small">${{ item | property: header.attribute | number: '1.0-0' }}</span>
                          }
                          @case ('number') {
                            <span class="small">{{item | property: header.attribute | number: '1.0-0'}}</span>
                          }
                          @case ('date') {
                            <span class="small">{{item | property: header.attribute | date: dateFormats.ddMMyyyy}}</span>
                          }
                          @case ('datetime') {
                            <span class="small">{{item | property: header.attribute | date: dateFormats.ddMMyyyyhhmma}}</span>
                          }
                          @case ('description') {
                            <span class="small d-inline-block text-truncate" style="width: 300px; white-space: normal; word-wrap: break-word;">
                              {{item | property: header.attribute}}
                            </span>
                          }
                          @default {
                            <span class="small">{{item | property: header.attribute}}</span>
                          }
                        }

                      }

                    }
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
        @if (footerData.length) {
          <tfoot>
            @for (dataRow of footerData; track $index) {
              <tr>
                @for (data of dataRow; track $index) {
                  <td class="fw-bold">{{data}}</td>
                }
              </tr>
            }
          </tfoot>
        }
      </table>
    </div>
  } @else {
    <p  class="text-secondary my-3 m-auto" style="width: fit-content">{{noItemsTitle}}</p>
  }

</div>
@if (pagination) {
  <div class="card-footer px-2 border-0 bg-white">
    <nav class="mx-auto d-block" style="width: fit-content;">
      <ul class="pagination m-0">
        <li class="page-item">
          <button (click)="prevPage()" [disabled]="pagination.currentPage == 1" aria-label="Previous" class="page-link text-secondary">
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        <li>
          <a class="page-link border-start-0 text-secondary">
            {{pagination.currentPage}}/{{pagination.totalPages}}
          </a>
        </li>
        <li class="page-item">
          <button (click)="nextPage()" [disabled]="pagination.currentPage == pagination.totalPages" aria-label="Next" class="page-link text-secondary">
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </nav>
  </div>
}
